import { render, staticRenderFns } from "./no-lab-banner.vue?vue&type=template&id=49355d78&"
import script from "./no-lab-banner.vue?vue&type=script&lang=js&"
export * from "./no-lab-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49355d78')) {
      api.createRecord('49355d78', component.options)
    } else {
      api.reload('49355d78', component.options)
    }
    module.hot.accept("./no-lab-banner.vue?vue&type=template&id=49355d78&", function () {
      api.rerender('49355d78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/labs/no-lab-banner.vue"
export default component.exports